
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:flex;
}

.search-container{
  display:flex;
  flex-direction:row-reverse;
  align-items:center;
  position:absolute;
  overflow:hidden;
  right:0;
  border-radius:5px;
  transition:all 0.3s ease-in-out;
  background-color:var(--brand-dark-blue-900);
  border:2px solid var(--brand-dark-blue-900);
}

.search-container:hover{
    border-color:var(--outline-white);
  }

.search-container.expanded{
    width:100% !important;
    border-color:var(--outline-white);
    padding-left:1rem;
  }

.search-container.mobile{
  position:static;
  width:100% !important;
  height:auto !important;
  padding:6px 10px 6px 16px;
  border:2px solid var(--outline-white);
}

.search-wrapper.mobile{
  width:100% !important;
  height:auto !important;
}

.separator{
  height:24px;
  width:2px;
  margin-left:1rem;
  margin-right:0.25rem;
  background-color:var(--brand-green-900);
}

.btn.link.search-button:focus-visible{
    border-radius:5px;
    outline:2px solid var(--outline-white);
    outline-offset:-6px;
  }

::slotted([slot='search-form']){
  display:flex;
  flex:1;
}
`;